module.exports = __webpack_public_path__ + "static/media/1.question.64774c65.mp4";